import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import ListItemButton from '@material-ui/core/ListItemButton';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';

import routeConfigs from '../../routes/_routeConfigs';
import { useAuth } from '../../utils/auth';

const MenuList = ({ isMobileWidth, setOpen }) => {
  const auth = useAuth();
  const history = useHistory();

  const currentRoute = useSelector((state) => state.router.current);

  const [expandItemList, setExpandItemList] = useState([]);
  const [selectedItemName, setSelectedItemName] = useState();
  const [userIsAdmin, setUserIsAdmin] = useState(false);

  useEffect(() => {
    if (currentRoute.isMenuItem && !currentRoute.hasChildren) {
      setSelectedItemName(currentRoute.name);
    }
  }, [currentRoute]);

  useEffect(() => {
    setUserIsAdmin(auth && auth.user && auth.user.isAdmin);
  }, [auth, auth.user]);

  const toggleExpand = (name) => {
    const newList = [...expandItemList];

    if (newList.includes(name)) {
      newList.remove(name);
      setExpandItemList(newList);
    } else {
      newList.push(name);
      setExpandItemList(newList);
    }
  };

  const handleListItemClick = (route, parentRoute) => {
    if (route.children) {
      toggleExpand(route.name);
    } else {
      const targetRoutePath = parentRoute
        ? parentRoute.path + route.path
        : route.path;
      setSelectedItemName(route.name);
      if (route.name !== currentRoute.name) {
        if (isMobileWidth) {
          setOpen(false);
        }
        history.push(targetRoutePath);
      }
    }
  };

  return (
    <List>
      {routeConfigs.map((route) =>
        route.isMenuItem &&
        !(route.isAdminOnly && !userIsAdmin) &&
        !(route.isNormalOnly && userIsAdmin) ? (
          <div key={route.name + '-item'}>
            <ListItemButton
              selected={selectedItemName === route.name}
              onClick={() => handleListItemClick(route)}
            >
              {route.icon ? (
                <ListItemIcon>
                  <Icon component={route.icon} />
                </ListItemIcon>
              ) : undefined}

              <ListItemText
                primary={route.menuLabel || (route.meta && route.meta.title)}
              />
              {route.children ? (
                expandItemList.includes(route.name) ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : undefined}
            </ListItemButton>
            {route.children ? (
              <Collapse
                key={route.name + '-coolapse'}
                in={expandItemList.includes(route.name)}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {route.children.map((subRoute) =>
                    subRoute.isMenuItem &&
                    !(subRoute.isAdminOnly && !userIsAdmin) &&
                    !(subRoute.isNormalOnly && userIsAdmin) ? (
                      <ListItemButton
                        key={subRoute.name + '-subItem'}
                        sx={{ pl: 4 }}
                        selected={selectedItemName === subRoute.name}
                        onClick={() => handleListItemClick(subRoute, route)}
                      >
                        {subRoute.icon ? (
                          <ListItemIcon>
                            <Icon component={subRoute.icon} />
                          </ListItemIcon>
                        ) : undefined}
                        <ListItemText
                          primary={
                            subRoute.menuLabel ||
                            (subRoute.meta && subRoute.meta.title)
                          }
                        />
                      </ListItemButton>
                    ) : undefined
                  )}
                </List>
              </Collapse>
            ) : undefined}
          </div>
        ) : undefined
      )}
    </List>
  );
};

MenuList.propTypes = {
  isMobileWidth: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default MenuList;
